import { render, staticRenderFns } from "./ServiceTypePDF.vue?vue&type=template&id=ad68ca2a&scoped=true&"
import script from "./ServiceTypePDF.vue?vue&type=script&lang=js&"
export * from "./ServiceTypePDF.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypePDF.vue?vue&type=style&index=0&id=ad68ca2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad68ca2a",
  null
  
)

export default component.exports